import { ModuleWithProviders, NgModule } from '@angular/core';
import { handleBatchAction } from '@k2/common/state/batch-action';
import { handleUndo } from "@k2/common/ngrx-undo-replacement/handleUndo";
import { rootMetaReducerAssignments } from '@k2/common/assignments-state/reducers';

export const rootMetaReducers = [handleUndo, handleBatchAction, rootMetaReducerAssignments];

@NgModule({})
export class StateModule {
  static forRoot(): ModuleWithProviders<StateModule> {
    return {
      ngModule: StateModule
    };
  }
}
